<template>
  <modal v-cloak v-model="modalVisible" title="E-mail Bag" @show="onShow" :footer="false">
    <div class="row row-margin">
      <div class="col-sm-offset-2 col-sm-8">
        <error-list v-if="errorObject" :error-object="errorObject"/>

        <form v-show="submitted == 0" @submit.stop.prevent="submit">
          <p>An email will be sent to the address below that will allow you to recover your current bag contents at a later time on any device.</p>
          <div class="form-group" :class="{ 'has-error': $v.email.$error }">
            <label>Email Address</label>
            <input v-model.trim="email"
               type="email"
               class="form-control input-sm" placeholder="Email Address" required>
            <span
              v-show="$v.email.$error"
              class="help-block">
              Please enter a valid email.
            </span>
          </div>

          <div class="form-group" :class="{ 'has-error': $v.recaptchaResponse.$error }">
            <vue-recaptcha class="pull-right"
               :sitekey="recaptchaKey"
               ref="recaptcha"
               @verify="onVerify"
               @expired="onExpired"/>
            <div class="clearfix"></div>
            <span
              v-show="$v.recaptchaResponse.$error"
              class="help-block">
              Please verify you are a real person.
            </span>
          </div>

          <button class="btn btn-primary btn-sm btn-text pull-right" @click.prevent="submit">
            <i class="glyphicon glyphicon-envelope"></i> E-mail Bag
          </button>
          <div class="clearfix"></div>
        </form>
        <div class="vue-modal-success" v-show="submitted == 1">Processing...</div>
        <div class="vue-modal-success" v-show="submitted == 2">E-mail has been sent.</div>
      </div>
    </div>
  </modal>
</template>

<style scoped>
</style>

<script>
import { Modal } from 'uiv'
import VueRecaptcha from 'vue-recaptcha';
import { required, email } from 'vuelidate/lib/validators'
import ErrorList from "./ErrorList"
import { ErrorListMixin }  from '../mixins/ErrorListMixin'
import { RecaptchaMixin } from '../mixins/RecaptchaMixin'
import { ModalMixin } from '../mixins/ModalMixin'

export default {
    components: {
        'error-list': ErrorList,
        'modal': Modal,
        'vue-recaptcha': VueRecaptcha,
    },

    mixins: [ErrorListMixin, RecaptchaMixin, ModalMixin],

    props: {
        modalName: {
            type: String,
            default: 'emailCart'
        },
    },

    data () {
        return {
            email: null,
        }
    },

    validations: {
        email: {
            required,
            email
        },
        recaptchaResponse: {
            required,
        }
    },

    methods: {
        prepSubmission: function () {
            this.$v.$reset()
            this.prepErrorList()
            this.prepRecaptcha(this.$refs.recaptcha)
        },

        onShow: function () {
            this.email = null
            this.errorObject = null
            this.prepSubmission()
        },

        submit: async function () {
            this.$v.$touch()
            if (!this.$v.$error) {
                this.postAndErrorCheck('/cart/email-cart', {
                    email: this.email,
                    'g-recaptcha-response': this.recaptchaResponse
                }, null, this.prepSubmission)
            }
        },
    },
}
</script>
